import React from "react";

function NumSubmits({ numSubmits, numFills }) {
  if (numSubmits !== null && numFills !== null) {
    return (
      <div>
        <p className="text-center">
          <i>
            Fun Fact: This tool has been used{" "}
            {numSubmits.toLocaleString("en-US")} times and has{" "}
            {numFills.toLocaleString("en-US")} tire sizes in its database.
          </i>
        </p>
      </div>
    );
  } else {
    return <div></div>;
  }
}

export default NumSubmits;
